export enum TraceReplayStatus {
  PlayInProgress = 'PlayInProgress',
  Paused = 'Paused'
}
